import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { resolveSEO } from '@/seo-config';

/**
 * Per-page SEO injection at runtime.
 * Static social-media metadata is also generated at build time by
 * `scripts/prerender.js`, using the same `seo-config.js` source of truth,
 * so non-JS scrapers (Facebook, LinkedIn, Twitter) see correct tags too.
 */
const SEO = ({ title, description, image, noindex = false, canonical }) => {
  const location = useLocation();
  const path = canonical || location.pathname;
  const resolved = resolveSEO(path, { title, description, image });

  return (
    <Helmet prioritizeSeoTags>
      <title>{resolved.title}</title>
      <meta name="description" content={resolved.description} />
      <link rel="canonical" href={resolved.url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={resolved.title} />
      <meta property="og:description" content={resolved.description} />
      <meta property="og:url" content={resolved.url} />
      <meta property="og:image" content={resolved.image} />

      {/* Twitter */}
      <meta name="twitter:title" content={resolved.title} />
      <meta name="twitter:description" content={resolved.description} />
      <meta name="twitter:image" content={resolved.image} />
    </Helmet>
  );
};

export default SEO;
